import { IUserHistoryItem } from '../../api/logs.types'

const EVENT_LABEL: Record<string, string> = {
  CREATED: 'Учётная запись создана',
  BLOCKED: 'Учётная запись заблокирована',
  UNBLOCKED: 'Учётная запись разблокирована',
  SECOND_FACTOR_ENABLED: 'Второй фактор включён',
  SECOND_FACTOR_DISABLED: 'Второй фактор выключен',
  SECOND_FACTOR_RESET: 'Второй фактор снят',
  SECOND_FACTOR_FAILED: 'Неудачное подтверждение второго фактора',
  PASSWORD_CHANGED: 'Пароль изменён',
}

/** The events an account log can be narrowed to, in the order they are offered. */
export const USER_EVENT_OPTIONS = Object.entries(EVENT_LABEL).map(([value, label]) => ({ value, label }))

const METHOD_LABEL: Record<string, string> = {
  totp: 'приложение',
  passkey: 'ключ',
  recovery_code: 'резервный код',
}

/** What happened to an account, in words; an event unknown here is shown by its code, not hidden. */
export const userEventLabel = (item: Pick<IUserHistoryItem, 'eventType' | 'eventData'>): string => {
  const label = EVENT_LABEL[item.eventType] ?? item.eventType
  const data = item.eventData as unknown
  const method =
    data && typeof data === 'object' && !Array.isArray(data) ? (data as { method?: unknown }).method : undefined
  const methodLabel = typeof method === 'string' ? METHOD_LABEL[method] : undefined

  return methodLabel ? `${label} (${methodLabel})` : label
}
